import { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppHeader } from "./appheader";
import { AppBody } from "./appbody";
import { MobileBottomNavigation } from "./mobilebottomnavigation";
import "../styles/mobileexperience.css";

export const MainLayout = props =>{
    //i added this just to force main layout to re-render when current user / current theme change; this is optional
    //the app will work fine even without it
    const currentUser = useSelector(state => state.currentUser);
    const currentTheme = useSelector(state => state.currentTheme);

    return(
        <div className="main-layout">            
            <AppHeader />
            <AppBody />
            {currentUser?.IsAuthenticated && <MobileBottomNavigation />}
            <style>
                {
                    `
                    .main-layout
                    {
                        display: flex; 
                        flex-direction: column;
                    }
                    `
                }
            </style>
        </div>
    )
}
